import { Link } from "react-router-dom";
import { MapPin, MessageCircle, Linkedin, ArrowUpRight } from "lucide-react";
import CopyableEmail from "@/components/CopyableEmail";

const WHATSAPP_NUMBER = "+91 89172 09551";
const WHATSAPP_HREF = "https://wa.me/918917209551";
const LINKEDIN_HREF = "https://www.linkedin.com/company/auraadesigns"; // TBD — confirm

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-bone border-t border-borderwarm">
      <div className="container-luxury pt-20 md:pt-28 pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-6">
            <div className="text-[11px] uppercase tracking-[0.32em] text-oxblood font-medium mb-6">
              The Auraa Atelier
            </div>
            <div className="font-serif text-[36px] md:text-[52px] lg:text-[60px] leading-[1.02] tracking-[-0.02em] text-espresso text-balance">
              Hospitality identity,
              <br />
              <em className="italic text-oxblood">designed in cloth.</em>
            </div>
            <Link
              to="/consultation"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 mt-9 text-[11px] uppercase tracking-[0.28em] text-espresso border-b border-espresso pb-1 hover:text-oxblood hover:border-oxblood transition-colors duration-500"
            >
              Begin a consultation
              <ArrowUpRight
                size={14}
                className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </Link>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <div className="text-[10px] uppercase tracking-[0.32em] text-espresso-soft mb-5">
              Navigate
            </div>
            <ul className="space-y-3 font-serif text-[19px] leading-tight">
              <li><Link className="text-espresso hover:text-oxblood transition-colors duration-500" to="/">Home</Link></li>
              <li><Link className="text-espresso hover:text-oxblood transition-colors duration-500" to="/about">About</Link></li>
              <li><Link className="text-espresso hover:text-oxblood transition-colors duration-500" to="/projects">Projects</Link></li>
              <li><Link className="text-espresso hover:text-oxblood transition-colors duration-500" to="/consultation">Consultation</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.32em] text-espresso-soft mb-5">
              Contact
            </div>
            <ul className="space-y-4 text-[14px] font-light text-espresso-soft">
              <li>
                <CopyableEmail testid="footer-email" />
              </li>
              <li>
                <a
                  href={WHATSAPP_HREF}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-2 text-espresso hover:text-oxblood transition-colors"
                >
                  <MessageCircle size={13} className="text-oxblood" />
                  <span>{WHATSAPP_NUMBER}</span>
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={13} className="text-oxblood" />
                <span>Bhubaneswar · Pan-India</span>
              </li>
              <li>
                <a
                  href={LINKEDIN_HREF}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="inline-flex items-center gap-2 text-espresso hover:text-oxblood transition-colors mt-2"
                >
                  <Linkedin size={13} className="text-oxblood" />
                  <span className="text-[11px] uppercase tracking-[0.24em]">LinkedIn</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-borderwarm">
        <div className="container-luxury py-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-[18px] tracking-tight text-espresso">Auraa</span>
            <span className="text-[10px] uppercase tracking-[0.32em] text-espresso-soft">Designs</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-espresso-soft">
            © {new Date().getFullYear()} Auraa Designs · Bhubaneswar
          </div>
        </div>
      </div>
    </footer>
  );
}
